//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 15px;
    border: 1px solid var(--light-blue-1);
    border-radius: 4px;
    span {
        color: var(--light-gray-5);
        font-size: 14px;
    }
`;